import { render, staticRenderFns } from "./bp.vue?vue&type=template&id=ead0c956"
import script from "./bp.vue?vue&type=script&lang=js"
export * from "./bp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports